import React from 'react';
import { styled } from '@compiled/react';
import { Box, xcss } from '@atlaskit/primitives';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { CardDueDate } from '@atlassian/jira-platform-card/src/common/ui/due-date/index.tsx';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';

type Props = {
	dueDate: string | null;
	shouldRenderDueDateColumn: boolean;
	isDone: boolean;
};

export const DueDate = ({ dueDate, shouldRenderDueDateColumn, isDone }: Props) => {
	const cardDueDate = dueDate || '';
	const dueDateNode = <CardDueDate dueDate={cardDueDate} isCompleted={isDone} isShortFormat />;

	return isVisualRefreshEnabled() ? (
		<Box
			testId="software-backlog.card-list.card.card-contents.due-date"
			xcss={[wrapperStyles, shouldRenderDueDateColumn && wrapperStylesWithColumn]}
		>
			{cardDueDate ? dueDateNode : null}
		</Box>
	) : (
		<CardDueDateWrapper
			shouldRenderColumn={shouldRenderDueDateColumn}
			hasDueDate={dueDate !== null}
			data-testid="software-backlog.card-list.card.card-contents.due-date"
			visualRefresh={isVisualRefreshEnabled()}
		>
			{cardDueDate ? dueDateNode : null}
		</CardDueDateWrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CardDueDateWrapper = styled.div<{
	shouldRenderColumn: boolean;
	hasDueDate: boolean;
	visualRefresh: boolean;
}>(
	{
		display: 'flex',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	(props) =>
		props.shouldRenderColumn
			? {
					minWidth: props.visualRefresh
						? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
							`${props.hasDueDate ? `${gridSize * 7.5}px` : `${gridSize * 9.6}px`}`
						: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
							`${props.hasDueDate ? `${gridSize * 7.5}px` : `${gridSize * 8}px`}`,
				}
			: {},
);

const wrapperStyles = xcss({
	display: 'flex',
});

const wrapperStylesWithColumn = xcss({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
	minWidth: `${gridSize * 10.2}px`,
});
